import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ICProdProvProvider,
  ICProdProvProviderMethods
} from "@/models/providers/contractProduct";

@Component
export default class CProdProvInjectorMixin extends Vue {
  // Inject

  @Inject({ from: "cProdProvProvider" })
  private readonly $cProdProvData!: () => ICProdProvProvider;

  @Inject({ from: "cProdProvProviderMethods" })
  public readonly $cProdProvMethods!: ICProdProvProviderMethods;

  // Computed

  public get cProdProvData() {
    return this.$cProdProvData();
  }
}
